import { useMemo } from 'react';
import { UserAttributeKeys } from '../userAttributes/userAttributesTypes';
import { useUserAttribute } from '../userAttributes/userAttributesQueries';
import { userCompletedContentAfterQuiz } from './recommendationsUtils';
import { useAllProgress } from '../userProgress/userProgressQueries';
export { useSetLastClickedRecommendationItemFromUrl } from 'academy-common-lib/features/recommendations/recommendationsHooks';
export const usePrioritizeInterestRecommendations = () => {
  const {
    allProgress: {
      contentProgress
    },
    allProgressLoading: isRequestingProgress
  } = useAllProgress();
  const {
    userAttribute: quizCompletionDate,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const prioritizeInterestRecommendations = useMemo(() => {
    if (isRequestingProgress || userAttributeLoading) return undefined;
    return !!quizCompletionDate && !userCompletedContentAfterQuiz(quizCompletionDate, contentProgress);
  }, [contentProgress, isRequestingProgress, quizCompletionDate, userAttributeLoading]);
  const isLoading = prioritizeInterestRecommendations === undefined;
  return {
    prioritizeInterestRecommendations,
    isLoading,
    hasError: userAttributesError
  };
};